export default {"src":"/_next/static/media/rabby.8e856a83.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};